import _Delete from "@mui/icons-material/Delete";
import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { authorizedAPI } from 'app/services/api';
import DeleteDialog from 'app/components/dialog/DeleteDialog';
import isAxiosError from 'app/helpers/isAxiosError';
const deleteGoalEvent = (matchSlug, matchEventId) => {
  return authorizedAPI.delete("/matches/".concat(matchSlug, "/goals/").concat(matchEventId));
};
export default function DeleteScorerButton(_ref) {
  let {
    matchEventId,
    matchSlug,
    onDelete,
    onError
  } = _ref;
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleDelete = () => {
    deleteGoalEvent(matchSlug, matchEventId).then(() => {
      handleClose();
      onDelete(matchEventId);
    }).catch(error => {
      handleClose();
      if (isAxiosError(error)) {
        var _error$response;
        const errorData = (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error;
        if (errorData !== null && errorData !== void 0 && errorData.translated_message) {
          return onError(errorData.translated_message);
        }
      }
      return onError('Beim Löschen ist ein unbekannter Fehler aufgetreten, versuche es später erneut.');
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    title: "Torsch\xFCtze l\xF6schen",
    onClick: () => setOpen(true),
    sx: {
      justifySelf: 'center'
    },
    "data-sentry-element": "IconButton",
    "data-sentry-source-file": "DeleteScorerButton.tsx"
  }, /*#__PURE__*/React.createElement(_Delete, {
    color: "action",
    "data-sentry-element": "Delete",
    "data-sentry-source-file": "DeleteScorerButton.tsx"
  })), /*#__PURE__*/React.createElement(DeleteDialog, {
    description: "Der Eintrag im Liveticker wird gel\xF6scht, der Spielstand bleibt unver\xE4ndert.",
    open: open,
    onReject: handleClose,
    onResolve: handleDelete,
    title: "Torsch\xFCtze l\xF6schen?",
    "data-sentry-element": "DeleteDialog",
    "data-sentry-source-file": "DeleteScorerButton.tsx"
  }));
}